import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/src/app/global-error.tsx");
